import React, { createContext, useState } from "react";
import PropTypes from "prop-types";
import { committeeList } from "Apis/committees";
import { memberList } from "Apis/member";
import { getJsonData } from "Apis/utils";

export const CommitteeContext = createContext();

export const CommitteeContextProvider = ({ children }) => {
  const [editData, setEditData] = useState([]);
  const [committeeTagList, setCommitteeTagList] = useState([]);
  // const [memberData, setMemberData] = useState([]);
  const [tagdata, setTagData] = useState([]);

  const handleCommitteeList = async () => {
    let response = await committeeList();
    if (response?.status === 200) {
      if (response?.status === 200) {
        const committeeData = response?.data?.data?.rows?.map((committee) => ({
          label: committee?.tag,
          value: committee?.id,
        }));
        setCommitteeTagList(committeeData);
      }
    }
  };

  // const handleMemberList = async () => {
  //   let response = await memberList();
  //   if (response?.status === 200) {
  //     const members = response?.data?.data?.rows?.map((member) => ({
  //       label: member?.first_name + " " + member?.middle_name + " " + member?.surname,
  //       value: member?.id,
  //       imageUrl: member?.member_images[0]?.image,
  //     }));
  //     setMemberData(members);
  //   }
  // };

  // Json Listing
  const jsonListing = async () => {
    let data = await getJsonData();
    if (data?.status === 200) {
      const tagDataOptions = data?.data?.data?.committeeData?.map((tag) => ({
        label: tag.label,
      }));
      setTagData(tagDataOptions);
    }
  };

  return (
    <CommitteeContext.Provider
      value={{
        editData,
        setEditData,
        committeeTagList,
        handleCommitteeList,
        // handleMemberList,
        // memberData,
        // setMemberData,
        tagdata,
        jsonListing,
      }}
    >
      {children}
    </CommitteeContext.Provider>
  );
};

export default CommitteeContextProvider;
CommitteeContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
